import { types } from './actions';

const initialState = {
  id: null,
};

const reducer = (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case types.SET_ID:
      return {
        ...state,
        id: payload.id,
      };
    default:
      return state;
  }
};

export default reducer;
